module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/tecnico/tecnico.component.css
// module id = ./src/app/tecnico/tecnico.component.css
// module chunks = main